(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('NotificationService', NotificationService)

    /** @ngInject */
    function NotificationService($httpParamSerializer, HttpService) {
        const NotificationService = {
            getAll: getAll,
            getHighlighted: getHighlighted,
            getCount: getCount,
            postAll: postAll,
            post: post
        }

        return NotificationService;

        function getAll(personId, responsibilityId, perPage, skip) {
            return HttpService.get(`/notifications/${personId}/${responsibilityId}?perPage=${perPage}&skip=${skip}`);
        }

        function getHighlighted() {
            return HttpService.get('/applications/all?getHighlighted=true');
        }

        function getCount(personId, responsibilityId) {
            return HttpService.get(`/notifications/count/${personId}/${responsibilityId}`);
        }

        function post(accessLog) {
            return HttpService.post('/notifications/access-log', accessLog);
        }

        function postAll(personId, responsibilityId, isDelete = null) {
            let params = {
                personId: personId,
                responsibilityId: responsibilityId
            }

            if (isDelete != null)
                params.isDelete = isDelete;

            return HttpService.post(`/notifications/access-log/all?${$httpParamSerializer(params)}`);
        }
    }
}());